import script from "./PottingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PottingForm.vue?vue&type=script&setup=true&lang=js"

import "./PottingForm.vue?vue&type=style&index=0&id=ce336bd8&lang=css"

const __exports__ = script;

export default __exports__